import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WelcomeCard = ({ userName, user, onNewAnalysis }) => {
  const getGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <div className="bg-gradient-to-r from-primary to-secondary rounded-xl p-6 text-white">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <h1 className="text-2xl font-bold mb-2">
            {getGreeting()}, {userName?.split(' ')?.[0] || 'User'}! 👋
          </h1>
          <p className="text-blue-100 mb-4">
            Ready to take your career to the next level? Let's analyze your resume and find new opportunities.
          </p>
          <div className="flex items-center space-x-4">
            <Button
              variant="secondary"
              onClick={onNewAnalysis}
              iconName="Upload"
              iconPosition="left"
              className="bg-white text-primary hover:bg-blue-50"
            >
              New Analysis
            </Button>
            
          </div>
        </div>
        <div className="hidden md:block">
          <div className="w-24 h-24 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
            <Icon name="TrendingUp" size={40} className="text-white" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeCard;